import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';

/**
 * Read model for the user administration screen. Not AdornisUser, because that carries
 * `password` as a regular field — a caller could just select it.
 */
@Entity()
export class ManagedUser extends AdornisEntity {
  static override _class = 'ManagedUser';

  @Field(() => String) _id!: string;
  @Field(() => String) username: Maybe<string>;
  @Field(() => String) email: Maybe<string>;
  @Field(() => Date) createdAt: Maybe<Date>;

  @Field(() => Date) archivedAt: Maybe<Date>;

  @Field(() => Boolean) canManageUsers: Maybe<boolean>;

  constructor(doc: PartialEntityData<ManagedUser>) {
    super(doc);
  }
}
